import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fcef078"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "heading-lg loading-message" }
const _hoisted_3 = { class: "heading-xl text-center" }
const _hoisted_4 = {
  class: "text-center",
  "data-cy": "redirect-message"
}
const _hoisted_5 = {
  class: "heading-xl",
  "data-cy": "sign-in-title"
}
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "button-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "spacer" }, null, -1))
const _hoisted_9 = { class: "login-footer" }
const _hoisted_10 = { class: "hidden" }
const _hoisted_11 = ["action"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OneAppError = _resolveComponent("OneAppError")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_InlineError = _resolveComponent("InlineError")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MHForm = _resolveComponent("MHForm")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, {
    class: "login-wrapper",
    verticalCenter: true,
    logoDisplay: _ctx.showLogo && !_ctx.isOneApp,
    size: _ctx.size
  }, {
    default: _withCtx(() => [
      (_ctx.isOneApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('loadingMessageEllipsis')), 1)
          ]))
        : (_ctx.redirecting)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('redirect.heading')), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('redirect.Teladoc')), 1)
            ], 64))
          : (_ctx.livongoAuthStatus && _ctx.livongoAuthStatus.errorCode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.isOneApp)
                  ? (_openBlock(), _createBlock(_component_OneAppError, {
                      key: 0,
                      title: _ctx.loginErrorAlertTitle,
                      description: _ctx.loginErrorDescription,
                      buttonLabel: _ctx.$t('oneapp.buttonLabel'),
                      navigate: _ctx.navigate,
                      emailAddress: _ctx.emailAddress,
                      emailText: _ctx.emailText
                    }, null, 8, ["title", "description", "buttonLabel", "navigate", "emailAddress", "emailText"]))
                  : (!_ctx.isOneApp)
                    ? (_openBlock(), _createBlock(_component_Alert, {
                        key: 1,
                        title: _ctx.loginErrorAlertTitle,
                        externalDestination: _ctx.livongoPortalUrl,
                        type: _ctx.loginErrorType
                      }, null, 8, ["title", "externalDestination", "type"]))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_MHForm, {
                key: 3,
                as: "div",
                ref: "loginForm"
              }, {
                default: _withCtx(({ handleSubmit, meta }) => [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('heading')), 1),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.submitForm)), ["prevent"])
                  }, [
                    _createVNode(_component_BaseInputText, {
                      ref: "emailInput",
                      "data-cy": "email-input",
                      labelLocation: "top",
                      validationRules: "email|required",
                      autocomplete: "email",
                      validateMode: "lazy",
                      labelText: _ctx.$t('loginForm.emailField.label'),
                      inputName: _ctx.$t('loginForm.emailField.name'),
                      placeholder: _ctx.$t('loginForm.emailField.placeholder'),
                      inputModel: _ctx.email,
                      "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event))
                    }, null, 8, ["labelText", "inputName", "placeholder", "inputModel"]),
                    (_ctx.isLegacyUser)
                      ? (_openBlock(), _createBlock(_component_BaseInputText, {
                          key: 0,
                          ref: "passwordInput",
                          "data-cy": "password-input",
                          inputType: "password",
                          autocomplete: "current-password",
                          placeholder: "************",
                          labelLocation: "top",
                          validationRules: "required",
                          labelText: _ctx.$t('loginForm.passwordField.label'),
                          inputName: _ctx.$t('loginForm.passwordField.name'),
                          inputModel: _ctx.password,
                          "onUpdate:inputModel": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event))
                        }, null, 8, ["labelText", "inputName", "inputModel"]))
                      : _createCommentVNode("", true),
                    (_ctx.isLegacyUser && _ctx.loginFailed)
                      ? (_openBlock(), _createBlock(_component_InlineError, {
                          key: 1,
                          message: _ctx.$t('loginForm.loginFailureMessage')
                        }, null, 8, ["message"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (!_ctx.isLegacyUser)
                        ? (_openBlock(), _createBlock(_component_BaseButton, {
                            key: 0,
                            class: "btn-primary btn-submit-login",
                            type: "submit",
                            disabled: !meta.valid
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('loginForm.nextBtn')), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.isLegacyUser)
                        ? (_openBlock(), _createBlock(_component_BaseButton, {
                            key: 1,
                            class: "btn-primary btn-submit-login",
                            type: "submit",
                            disabled: !meta.valid || _ctx.isWaitingForLoginResponse
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(!_ctx.isWaitingForLoginResponse ? _ctx.$t('loginForm.signInBtn') : _ctx.$t('loadingMessageEllipsis')), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.isLegacyUser)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 2,
                            class: "link-forgot-password",
                            to: {"name":"PasswordReset"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('forgotPassword')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 40, _hoisted_6),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('createNewAccountLabel')) + " ", 1),
                    _createVNode(_component_router_link, {
                      class: "link-sign-up",
                      to: { name: 'SignUp' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('createNewAccount')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("form", {
                      ref: "SpInitiatedSSOForm",
                      method: "post",
                      action: _ctx.spInitiatedSSOUrl
                    }, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "emailAddress",
                        value: _ctx.email
                      }, null, 8, _hoisted_12),
                      _createElementVNode("input", {
                        type: "text",
                        name: "redirectUrl",
                        value: _ctx.redirectUrl
                      }, null, 8, _hoisted_13)
                    ], 8, _hoisted_11)
                  ])
                ]),
                _: 1
              }, 512))
    ]),
    _: 1
  }, 8, ["logoDisplay", "size"]))
}